module.exports = __webpack_public_path__ + "img/wollust.98c9b594.png";